import { OpportunityTagView, SearchTagsParameters, TagView } from '@api-proxies';
import { TagService } from '@http/clients/tag.service';
import { EntityTypes } from '@models/enums/EntityTypes';
import { TagEntity } from './abstract/tag-entity';

export class OpportunityTagEntity extends TagEntity<OpportunityTagView> {
    constructor(tagService: TagService) {
        super(tagService);
    }

    toDestination(entity: TagView): OpportunityTagView {
        return { id: 0, tagId: entity.id, entityTypeId: entity.entityTypeId, tagName: entity.name };
    }

    toSource(entity: OpportunityTagView): TagView {
        return { id: entity.tagId, entityTypeId: entity.entityTypeId ?? 0, name: entity.tagName };
    }

    async getSource(entityType: EntityTypes, filterText = ''): Promise<TagView[]> {
        return await this.tagService.search({
            filterText,
            entityTypeId: entityType
        } as SearchTagsParameters);
    }
}
